// extracted by mini-css-extract-plugin
module.exports = {"location":"Places_location__1tVRs","imageWrapper":"Places_imageWrapper__1ZE-i","locationType":"Places_locationType__2AaeF"};